import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { Box, Typography, Grid, Paper } from '@material-ui/core'
import { AppButton } from '../../Components'
import SummaryCard from '../../Components/SummaryCard'
import Requests from '../../Components/Requests'
import SystemsChart from '../../Components/SystemsChart'
import AdminAccounts from '../../Components/AdminAccounts'
import { useStyles } from './style'
import Breadcrumb from '../../Components/Breadcrumbs'
import { connect } from 'react-redux'

function Admin(props) {
  const classes = useStyles()
  const [totalRequests, setTotalRequests] = useState('')

  return (
    <Box>
      <Breadcrumb />
      <Box className={classes.headerWrapper}>
        <Typography className={classes.title}>Admin</Typography>
        <span className={classes.buttonContainer}>
          <AppButton className={`${classes.mr4} ${classes.buttons}`} text="Onboard CSIP Utility" onClick={() => props.history.push('admin/onboard-csip-utility')} fill={false} />
          <AppButton className={`${classes.mr4} ${classes.buttons}`} text="Create New Account" onClick={() => props.history.push('admin/create-new-account')} fill={false} />
          <AppButton className={classes.buttons} text="Create New Program" onClick={() => props.history.push('/program-request')} fill={false} />
        </span>
      </Box>
      <Box className={classes.headerWrapper}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Paper elevation={2} square>
              <SummaryCard setTotalRequests={setTotalRequests} />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper style={{ height: '100%' }} elevation={2} square>
              <Requests totalRequests={totalRequests} />
            </Paper>
          </Grid>
        </Grid>
      </Box>
      <Box className={classes.headerWrapper}>
        <Grid container >
          <Grid item xs={12}>
            <Paper elevation={2} square>
              {/* <SystemsChart /> */}
            </Paper>
          </Grid>
        </Grid>
      </Box>
      <Box className={classes.headerWrapper}>
        <Grid container>
          <Grid item xs={12}>
            <Paper elevation={2}>
              <AdminAccounts />
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

const mapStateToProps = ({ auth }) => {
  const { currentUser, isSuperAdmin } = auth
  return { currentUser, isSuperAdmin }
}

export default connect(mapStateToProps, {})(Admin)
